module.exports = ".items .item-list mat-list-item .title {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/admin/facility-types/facility-types.component.less
// module id = ./Angular/app/admin/facility-types/facility-types.component.less
// module chunks = main